// @flow
import querystring from 'querystring';

const onEnter = (info: {
  routeTo: (path: string, options: { replace: boolean }) => void,
  router: {
    next: {
      params: {
        [key: string]: string,
      },
      query: {
        [key: string]: string,
      },
    },
  },
}) => {
  const {
    routeTo,
    router: {
      next: { query, params },
    },
  } = info;
  const targetQuery = { ...query };
  // legacy param from /app/contact-us
  if (targetQuery.zaps) {
    targetQuery.zap = targetQuery.zaps;
    delete targetQuery.zaps;
  }
  if (params.zap) {
    targetQuery.zap = params.zap;
    targetQuery.topic = 'troubleshooting';
  } else if (params.app) {
    targetQuery.topic = 'developer';
    targetQuery.app = params.app;
  } else if (params.topic === 'trial') {
    targetQuery.topic = 'account';
    targetQuery.account = 'trial';
  }

  const qs = querystring.stringify(targetQuery);
  routeTo(`/app/get-help${qs ? `?${qs}` : ''}`, { replace: true });
};

const routes = {
  '/app/get-help': {
    fetch: () =>
      import(
        /* webpackChunkName: 'get-help-route' */ 'app/get-help/asyncRoute'
      ).then(module => module.default),
  },

  // SHORT ROUTES
  '/app/get-help/zap/:zap': {
    isAuthRequired: false,
    onEnter,
  },
  '/app/get-help/dev-app/:app': {
    isAuthRequired: false,
    onEnter,
  },
  '/app/get-help/topic/:topic': {
    isAuthRequired: false,
    onEnter,
  },

  // LEGACY ROUTES
  '/app/contact-us': {
    isAuthRequired: false,
    onEnter,
  },
  '/app/contact-us/zap/:zap': {
    isAuthRequired: false,
    onEnter,
  },
  '/app/contact-us/dev-app/:app': {
    isAuthRequired: false,
    onEnter,
  },
  '/app/contact-us/topic/:topic': {
    isAuthRequired: false,
    onEnter,
  },

  // COMPATIBILITY ROUTES
  '/app/contact': {
    isAuthRequired: false,
    onEnter,
  },
};

export default routes;
